import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var ComplianceInspectionLetterDate =
/*#__PURE__*/
function (_BaseData) {
  _inherits(ComplianceInspectionLetterDate, _BaseData);

  function ComplianceInspectionLetterDate() {
    _classCallCheck(this, ComplianceInspectionLetterDate);

    return _possibleConstructorReturn(this, _getPrototypeOf(ComplianceInspectionLetterDate).call(this, "ComplianceInspectionLetterDate"));
  }

  _createClass(ComplianceInspectionLetterDate, [{
    key: "GetInspectionRelatedRows",
    value: function () {
      var _GetInspectionRelatedRows = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(inspectionId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetInspectionRelatedRows/").concat(inspectionId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetInspectionRelatedRows(_x) {
        return _GetInspectionRelatedRows.apply(this, arguments);
      }

      return GetInspectionRelatedRows;
    }()
  }, {
    key: "SendShowPropertyLetterDateEmail",
    value: function () {
      var _SendShowPropertyLetterDateEmail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(ComplianceInspectionLetterDateId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.post("/api/".concat(this._controller, "/SendShowPropertyLetterDateEmail/").concat(ComplianceInspectionLetterDateId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function SendShowPropertyLetterDateEmail(_x2) {
        return _SendShowPropertyLetterDateEmail.apply(this, arguments);
      }

      return SendShowPropertyLetterDateEmail;
    }()
  }]);

  return ComplianceInspectionLetterDate;
}(BaseData);

export default new ComplianceInspectionLetterDate();